import type { Client } from "@shared/types";

interface ClientLogoProps {
  client: Client;
  className?: string;
}

export default function ClientLogo({ client, className = "" }: ClientLogoProps) {
  if (client.svgCode) {
    const color = client.svgColor || "#ffffff";
    const coloredSvg = client.svgCode
      .replace(/fill="[^"]*"/g, `fill="${color}"`)
      .replace(/fill\s*:\s*#[0-9a-fA-F]{3,8}/g, `fill:${color}`)
      .replace(/fill\s*:\s*rgb[^;)]+[;)]/g, `fill:${color};`)
      .replace(/<svg([^>]*)>/, (_match, attrs) => {
        const attrStr = attrs as string;
        // Extract width/height before removing them, to build viewBox if missing
        const wMatch = attrStr.match(/\bwidth\s*=\s*"([^"]*)"/);
        const hMatch = attrStr.match(/\bheight\s*=\s*"([^"]*)"/);
        const hasViewBox = /\bviewBox\s*=/.test(attrStr);
        let newAttrs = attrStr
          .replace(/\bwidth\s*=\s*"[^"]*"/g, "")
          .replace(/\bheight\s*=\s*"[^"]*"/g, "");
        // Add viewBox from width/height if none exists
        if (!hasViewBox && wMatch && hMatch) {
          newAttrs += ` viewBox="0 0 ${wMatch[1]} ${hMatch[1]}"`;
        }
        return `<svg${newAttrs} fill="${color}" style="height:100%;width:auto;max-width:100%">`;
      });
    return (
      <div
        className={className}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        dangerouslySetInnerHTML={{ __html: coloredSvg }}
        aria-label={client.name}
        role="img"
      />
    );
  }

  if (client.logo) {
    return <img src={client.logo} alt={client.name} className={className} />;
  }

  return null;
}
